import { GetSymbolsResponse, MarketLayoutNode, SortedSymbols } from '@flipster/apis/v2/market/types';
import { InstrumentApi } from '@flipster/apis/v2/snapshot/types';

export const isTradFiInstrument = (instrument?: InstrumentApi | null): boolean =>
  instrument?.tags?.includes('TradFi') ?? false;

export const defaultTradFiSymbol = 'XAUUSDT.PERP';

export type TradFiCategory = 'all' | 'preIpo' | 'stock' | 'etf' | 'commodity';
export const tradFiCategories = ['all', 'preIpo', 'stock', 'etf', 'commodity'] as const satisfies TradFiCategory[];

const tradFiSectionType = 'SECTION_TYPE_TRADFI';

const subsectionTypeToTradFiCategory: Record<string, TradFiCategory> = {
  SUBSECTION_ALL: 'all',
  SUBSECTION_PRE_IPO: 'preIpo',
  SUBSECTION_STOCK: 'stock',
  SUBSECTION_ETF: 'etf',
  SUBSECTION_COMMODITY: 'commodity',
};

const tradFiCategoryDataKey = {
  all: 'tradfi.all',
  preIpo: 'tradfi.pre_ipo',
  stock: 'tradfi.stock',
  etf: 'tradfi.etf',
  commodity: 'tradfi.commodity',
} as const satisfies Record<TradFiCategory, keyof SortedSymbols>;

const findTradFiSubsections = (nodes: MarketLayoutNode[] | undefined): MarketLayoutNode[] => {
  for (const node of nodes ?? []) {
    if (node.type === tradFiSectionType) return node.children ?? [];
    const found = findTradFiSubsections(node.children);
    if (found.length) return found;
  }
  return [];
};

export const getTradFiCategorySymbols = (
  response: GetSymbolsResponse | undefined,
  category: TradFiCategory,
): string[] => response?.data[tradFiCategoryDataKey[category]]?.map((item) => item.symbol) ?? [];

export const getAvailableTradFiCategories = (response: GetSymbolsResponse | undefined): TradFiCategory[] =>
  findTradFiSubsections(response?.layout.components)
    .map((subsection) => subsectionTypeToTradFiCategory[subsection.type])
    .filter((category): category is TradFiCategory => Boolean(category))
    .filter((category) => getTradFiCategorySymbols(response, category).length > 0);
